import Q from 'q';

import API from 'js/lib/api';

export default (
  email: string,
  name: string,
  password: string,
  token: string,
  redirectUrl?: string,
  verificationEmailRedirectUrl?: string,
  skipWelcomeEmail?: boolean
) => {
  const api = API('', { type: 'post' });

  // verifyEmail is a required field on BE
  const data = {
    email,
    verifyEmail: email,
    name,
    password,
    recaptchaToken: token,
    redirectTo: redirectUrl,
    verificationEmailRedirectUrl,
    skipWelcomeEmail,
  };

  return Q(api.post('api/register/v1', { data }));
};
